import styled from 'styled-components'

export const Container = styled.div<{ size?: 'small' | 'medium' | 'tall' }>`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;

  /* width: 228px; */

  padding: ${({ size }) => (size == 'small' ? 5 : 8)}px;
  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-page-faded, #fafafa);
`

export const SequenceTemplateLine = styled.div<{ size?: 'small' | 'medium' | 'tall' }>`
  display: flex;
  flex-direction: row;
  gap: ${({ size }) => (size == 'small' ? 2.5 : 4)}px;
`

export const TaskTemplateDot = styled.div<{ size?: 'small' | 'medium' | 'tall' }>`
  border-radius: 2px;
  background: var(--background-neutral, #dfe2ea);

  height: ${({ size }) => (size == 'small' ? 2.5 : 4)}px;
  width: ${({ size }) => (size == 'small' ? 8 : 20)}px;
`
